export default __webpack_public_path__ + "static/media/link_icon.bd671565.svg";